<template>
  <div>
    <admin-sidebar></admin-sidebar>
    <section id="dashboard">
		<div class="container-fluid">
			<div class="row">
				<div class="col-12">
					<div class="title">
						<h2>Admin Dashboard</h2>
					</div>
				</div>
			</div>
			<div class="row d-flex">
				<div class="col-xl-3 col-lg-3 col-md-6 col-sm-12" v-if="this.userOfType('superadmin','operations','finops')">
					<div class="btn-dashboard">
                        <router-link :to="{name: 'admin/requests'}">
                            <button
							v-bind:class="{ tablinks: true, active: true }"
							>Kërkesat për transport</button>
                        </router-link>
					</div>
				</div>
				<div class="col-xl-3 col-lg-3 col-md-6 col-sm-12" v-if="this.userOfType('superadmin','finops', 'driver')">
					<div class="btn-dashboard">
                        <router-link :to="{name: 'admin/clients'}">
                            <button
							v-bind:class="{ tablinks: true, active: true }"
							>Menaxhimi i klientëve</button>
                        </router-link>
					</div>
				</div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12" v-if="this.userOfType('superadmin')">
					<div class="btn-dashboard">
                        <router-link :to="{name: 'admin/users'}">
                            <button
							v-bind:class="{ tablinks: true, active: true }"
							>Agjentet</button>
                        </router-link>
					</div>
				</div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12" v-if="this.userOfType('superadmin','finops')">
					<div class="btn-dashboard">
                        <router-link :to="{name: 'admin/users'}">
                            <button
							v-bind:class="{ tablinks: true, active: true }"
							>Menaxhimi i Agjentëve</button>
                        </router-link>
					</div>
				</div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12" v-if="this.userOfType('superadmin','finances')">
					<div class="btn-dashboard">
                        <router-link :to="{name: 'admin/finances'}">
                            <button
							v-bind:class="{ tablinks: true, active: true }"
							>Financat</button>
                        </router-link>
					</div>
				</div>
                <div class="col-xl-3 col-lg-3 col-md-6 col-sm-12" v-if="this.userOfType('superadmin')">
					<div class="btn-dashboard">
                        <router-link :to="{name: 'admin/users'}">
                            <button
							v-bind:class="{ tablinks: true, active: true }"
							>Përdoruesit</button>
                        </router-link>
					</div>
				</div>

			</div>
		</div>
    </section>
  </div>
</template>

<style src="@/assets/admin/css/main.css">
</style>

<script>
import AdminSidebar from "@/components/admin/AdminSidebar";
import { mapGetters } from "vuex";
import "moment";

export default {
  name: "AdminHome",
  components: {
    AdminSidebar: AdminSidebar
  },
  computed: {
    ...mapGetters({
      requests: "requests/requests",
      requestType: "requests/requestType",
      requestCount: "requests/requestCount",
      currentPage: "requests/currentPage",
      totalPages: "requests/totalPages"
    })
  }
};
</script>
